import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../app/store";
import { CmsData } from "../types/General";

export interface General {
  cms: CmsData | null;
  isAuthModalVisible: boolean;
  ModalType: string;
}

const initialState: General = {
  cms: null,
  isAuthModalVisible: false,
  ModalType: "",
};

export const generalSlice = createSlice({
  name: "general",
  initialState,
  reducers: {
    resetCms: (state, action: PayloadAction<Pick<General, "cms">>) => {
      state.cms = action.payload.cms;
    },
    toggleAuthModal: (
      state,
      action: PayloadAction<Pick<General, "isAuthModalVisible" | "ModalType">>
    ) => {
      state.isAuthModalVisible = action.payload.isAuthModalVisible;
      state.ModalType = action.payload.ModalType;
    },
  },
});
export const { resetCms, toggleAuthModal } = generalSlice.actions;
export const getCms = (state: RootState) => state.general.cms;
export const isAuthModalVisible = (state: RootState) =>
  state.general.isAuthModalVisible;
export const ModalType = (state: RootState) => state.general.ModalType;

export default generalSlice.reducer;
